<template>
    <div class="container overflow-auto">
        <form
            v-if="operation != null"
            @submit="saveData"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            ref="dataForm"
        >
            <div class="data" >
                <label class="mt-3 mb-0" for="operation">Tipo de Operação</label>
                <b-form-input
                    type="text"
                    name="operation"
                    readonly
                    :value="operation.nome"
                />
                <label class="mt-3 mb-0" for="inspType">Placa</label>
                <b-form-input
                    type="text"
                    name="numberPlate"
                    readonly
                    :value="numberPlate"
                />
                <label class="mt-3 mb-0" for="inspName">Vistoriador</label>
                <b-form-input
                    type="text"
                    name="inspName"
                    readonly
                    :value="inspName"
                />

                <b-form-group
                    :class="{
                        'campo-obrigatorio': this.clientDataRequired
                    }"
                >
                    <label class="mt-3 mb-0">Nome do cliente</label>
                    <b-form-input
                        type="text"
                        v-model="dataFields.clientName"
                        name="clientName"
                        :required="this.clientDataRequired"
                        v-mask="{ regex: '[A-zÀ-ú ]*' }"
                    />
                </b-form-group>

                <b-form-group
                    :class="{
                        'campo-obrigatorio': this.clientDataRequired
                    }"
                >
                    <label class="mt-3 mb-0">Digite o e-mail do cliente</label>
                    <b-form-input
                        type="text"
                        v-model="dataFields.clientEmail"
                        name="clientEmail"
                        pattern="^[a-zA-Z0-9.!#$%&*+\/=?^_`\{\|\}~\-]+@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(;[a-zA-Z0-9.!#$%&*+\/=?^_`\{\|\}~\-]+@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*)*$"
                        @change="() => {if(typeof dataFields.clientEmail === 'string') dataFields.clientEmail = dataFields.clientEmail.trim()}"
                        class="campo-email"
                        :class="{
                            empty: !dataFields.clientEmail
                        }"
                        :required="this.clientDataRequired"
                        title='Um e-mail válido ou uma lista de e-mails válidos (separados por ";")'
                    />
                </b-form-group>

                <b-form-group>
                    <label class="mt-3 mb-0"> *Veículo </label>
                    <b-form-input
                        type="text"
                        v-model="dataFields.vehicle"
                        name="vehicle"
                        required
                        v-mask="{ regex: '[A-Za-z0-9 ]*' }"
                    />
                </b-form-group>
                <!-- KM Odometro é sempre obrigatório, mesmo se a empresa desativar esse campo, pois se estiver vazio, a api não aceita a vistoria -->
                <b-form-group>
                    <label class="mt-3 mb-0">*Km Odometro</label>
                    <b-form-input
                        maxlength="8"
                        size="8"
                        required
                        :name="'Km Odometro'"
                        v-model="dataFields['Km Odometro']"
                        type="tel"
                        v-mask="{ regex: '[0-9]*' }"
                    />
                </b-form-group>

                <span v-for="(field, index) in fields" v-bind:key="index">
                    <span
                        v-if="
                            (field.tela == 1 || field.tela == 2)
                                && field.ativo == 'True'
                                && field.descricao != 'Km Odometro'
                        "
                    >
                        <b-form-group v-if="field.descricao === 'Pertences Retirados'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-select
                                class="select-pertences"
                                v-model="dataFields[field.descricao]"
                                :options="pertencesOptions"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Nivel Combustivel'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <div class="div-slider-combustivel">
                                <range-slider
                                    class="range-slider-combustivel"
                                    min="0"
                                    max="100"
                                    step="12.5"
                                    v-model="dataFields[field.descricao]"
                                    :name="field.descricao"
                                    :required="field.required == 'True'"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Nivel do GNV'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <div class="div-slider-gnv">
                                <range-slider
                                    class="range-slider-gnv"
                                    min="0"
                                    max="100"
                                    step="25"
                                    v-model="dataFields[field.descricao]"
                                    :name="field.descricao"
                                    :required="field.required == 'True'"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Pneus'">
                            <label class="label-pneu">
                                <span v-if="field.required == 'True'">*</span>Pneus
                            </label>
                            <div class="div-pneu" v-for="index in qtdePneus" :key="index">
                                <label class="label-pneu">{{ listaPneus[index - 1] }}</label>
                                <b-form-select
                                    v-if="listaPneus[index - 1] === 'Estepe'"
                                    class="select-estado-pneu"
                                    v-model="dataFields.Pneus[listaPneus[index - 1]].Estado"
                                    :options="estadoEstepe"
                                    :name="field.descricao"
                                    :required="field.required == 'True'"
                                />
                                <b-form-select
                                    v-else
                                    class="select-estado-pneu"
                                    @change="askSetAllStateTires($event, index - 1)"
                                    v-model="dataFields.Pneus[listaPneus[index - 1]].Estado"
                                    :options="estadoPneus"
                                    :name="field.descricao"
                                    :required="field.required == 'True'"
                                />
                                <b-form-select
                                    v-if="
                                        tires.includes(
                                            dataFields.Pneus[listaPneus[index - 1]].Marca
                                        ) || dataFields.Pneus[listaPneus[index - 1]].Marca == null
                                    "
                                    class="select-pneu"
                                    @change="
                                        askSetAllTires($event, index - 1);
                                        update();
                                    "
                                    v-model="dataFields.Pneus[listaPneus[index - 1]].Marca"
                                    :options="tires"
                                    :name="field.descricao"
                                    :required="field.required == 'True'"
                                />

                                <span v-else style="display: flex" class="select-pneu">
                                    <b-form-input
                                        v-mask="{ regex: '[A-zÀ-ú0-9 ]*' }"
                                        v-model="dataFields.Pneus[listaPneus[index - 1]].Marca"
                                        :name="field.descricao"
                                        :required="field.required == 'True'"
                                    />
                                    <button class="resetTire" @click="resetTire(index - 1)">
                                        x
                                    </button>
                                </span>
                            </div>
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Bateria'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>Bateria
                            </label>
                            <b-form-select
                                v-if="dataFields[field.descricao]"
                                v-model="dataFields[field.descricao].estado"
                                :options="batteryOptions"
                                name="Bateria"
                                :required="field.required == 'True'"
                            />

                            <label class="mt-3 mb-0">
                                <span
                                    v-if="
                                        field.required == 'True'
                                            && dataFields.Bateria?.estado != 'Não'
                                    "
                                >
                                    *
                                </span>Marca
                            </label>
                            <b-form-select
                                v-if="dataFields[field.descricao]"
                                v-model="dataFields[field.descricao].marca"
                                :options="batteryBrandOptions"
                                name="Marca"
                                :required="
                                    field.required == 'True' && dataFields.Bateria?.estado != 'Não'
                                "
                                @change="testUtilizaOutraBateria()"
                            >
                            </b-form-select>

                            <label class="mt-1 mb-0" v-if="utilizaOutraBateria">
                                <span v-if="utilizaOutraBateria">*</span>Digite a marca
                            </label>
                            <b-form-input
                                v-if="utilizaOutraBateria"
                                :required="utilizaOutraBateria"
                                type="text"
                                v-model="dataFields[field.descricao].outraMarca"
                                :name="field.descricao"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'CRLV'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-input
                                type="number"
                                v-model="dataFields[field.descricao]"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Motorista'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-input
                                type="text"
                                v-model="dataFields['Motorista']"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Ano'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>
                                {{ field.descricao }}
                            </label>
                            <b-form-input
                                type="number"
                                min="1900" :max="((new Date()).getFullYear() + 2).toString()" step="1"
                                v-model="dataFields.Ano"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Chassi'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-input
                                type="text"
                                v-model="dataFields.Chassi"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Número Contrato'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-input
                                type="text"
                                v-model="dataFields['Numero Contrato']"
                                :name="field.descricao"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Local Atendimento'">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-input
                                type="text"
                                v-model="dataFields['Local Atendimento']"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group v-else-if="field.descricao === 'Situação do Veículo'">
                            <label class="mt-3 mb-0"><span v-if="field.required == 'True'">*</span>{{ field.descricao }}</label>
                            <b-form-select
                                v-model="dataFields[field.descricao]"
                                :options="vehicleSituation"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <b-form-group
                            v-else-if="field.descricao === 'Situação Local de Atendimento'"
                        >
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-select
                                v-model="dataFields[field.descricao]"
                                :options="situacaoLocalDeAtendimentoOptions"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                            />
                        </b-form-group>

                        <!-- b-form-group v-else v-model="dataFields[field.descricao]">
                            <label class="mt-3 mb-0">
                                <span v-if="field.required == 'True'">*</span>{{ field.descricao }}
                            </label>
                            <b-form-input
                                v-mask="{ regex: '[A-zÀ-ú0-9 ]*' }"
                                type="text"
                                v-model="dataFields[field.descricao]"
                                :name="field.descricao"
                                :required="field.required == 'True'"
                                />
                        </b-form-group -->
                    </span>
                </span>

                <b-form-group>
                    <label class="mt-3 mb-0"> Observação </label>
                    <b-form-input
                        v-mask="{ regex: '[A-zÀ-ú0-9 ]*' }"
                        v-model="dataFields.observacao"
                        name="observacao"
                    />
                </b-form-group>

                <b-form-group v-if="parseInt(operation.tipo_vistoria) === 2"> 
                    <label class="mt-3 mb-0"> Observação Coleta </label>
                    <b-form-input
                        v-mask="{ regex: '[A-zÀ-ú0-9 ]*' }"
                        v-model="dataFields.observacaoColeta"
                        name="observacaoColeta"
                    />
                </b-form-group>
            </div>
            <div class="container-buttons">
                <b-button class="mt-3 buttons" variant="success" type="button" @click.prevent="nextStage">
                    Próximo
                </b-button>
            </div>
        </form>

        <div id="sobreposicao-integracao" v-show="carregandoIntegracao">
            <font-awesome-icon icon="sync" spin size="4x"/>
            <div id="aviso-carregando-integracao">
                Buscando informações da integração...
            </div>
        </div>
    </div>
</template>

<script>
import { getTireManufacturers } from "@/helper/tireManufacturers";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add([faSync]);

import { BButton, BFormGroup, BFormInput, BFormSelect } from "bootstrap-vue";

import _ from "lodash";

import SaveStage from "@/controller/saveStage";
import iniciarVistoria from "@/services/vex/iniciarVistoria";
import logger from "@/services/vex/logger";
import statusDaEmpresa from "@/services/vex/statusDaEmpresa";
import Swal from "sweetalert2";
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";
export default {
    components: {
        RangeSlider,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BButton,
        "font-awesome-icon": FontAwesomeIcon,
    },
    data: function () {
        return {
            carregandoIntegracao: false,
            operation: null,
            numberPlate: null,
            inspName: null,
            fields: null,
            dadosIntegracao: null,
            dataFields: {},
            tires: [],
            pertencesOptions: [{ text: "Selecione" }, "Sim", "Não"],
            quizType: null,
            quizzes: null,
            configAEmpresaConfiguracoes: null,
            dadosIniciarVistoria: null,
            nomeDoCliente: null,
            batteryOptions: [{ text: "Selecione" }, "Sim", "Não", "Avariado"],
            batteryBrandOptions: [
                { text: "Selecione" },
                "Moura",
                "Ac Delco",
                "Heliar",
                "Bat's",
                "Bat's",
                "Zetta",
                "Original de Fábrica",
                "Outra",
                "Sem bateria",
            ],
            vehicleSituation: [
                {
                    text: "Selecione",
                },
            ],
            situacaoLocalDeAtendimentoOptions: [],
            qtdePneus: 0,
            listaPneus: [],
            estadoPneus: [
                { text: "Estado" },
                { text: "Novo", value: "N" },
                { text: "Bom", value: "B" },
                { text: "Ruim", value: "R" },
            ],
            estadoEstepe: [
                { text: "Estado" },
                { text: "Novo", value: "N" },
                { text: "Bom", value: "B" },
                { text: "Ruim", value: "R" },
                { text: "Sem estepe", value: "SE" },
            ],
            utilizaOutraBateria: false,

            enterpriseConfig: null,
            parametrosEmpresa: null,
            naoConsultarVistoriasApi: false,
            utilizaIntegracao: null,
            clientDataRequired: null
        };
    },
    mounted: async function () {
        const operation = this.$store.state.inspectionData.operation;
        if(_.isEmpty(operation)) {
            console.log("Nenhum tipo de operação carregado no state. Retornando...");
            this.$router.push("/").catch(() => {});
            return;
        }
        this.operation = operation;

        this.dataFields = this.$store.state.inspectionData.data;
        this.quizType = this.$store.state.inspectionData.quizType;
        this.numberPlate = this.$store.state.inspectionData.numberPlate;
        this.inspName = this.$store.state.enterprise.name;
        this.fields = JSON.parse(localStorage.getItem("dataFields"));

        this.enterpriseConfig = JSON.parse(localStorage.getItem("enterpriseConfig"));
        this.parametrosEmpresa = JSON.parse(localStorage.getItem("parametrosEmpresa"));
        const operationParams = this.$store.state.inspectionData.operation.parametros;

        this.clientDataRequired = operationParams["obriga_informe_informacoes_cliente"].ativo;
        
        this.utilizaIntegracao = this.parametrosEmpresa.utiliza_api_integracao == "True";
        this.naoConsultarVistoriasApi = operationParams["nao_consultar_vistorias_api"]?.ativo === true;
        
        const bloqueado = await this.checarStatusEmpresa();
        if(bloqueado) {
            localStorage.clear();
            this.$router.push({ path: "/login" });
            return;
        }

        this.carregandoIntegracao = true;
        await this.carregarDadosIniciarVistoria();
        this.tratarIntegracao(this.dadosIntegracao);
        this.carregandoIntegracao = false;

        const vehicleSituationValues = this.enterpriseConfig.opcoes_situacao_veiculo.valor.split("|");

        if (vehicleSituationValues.length > 0 && vehicleSituationValues[0] !== "") {
            vehicleSituationValues.forEach((value) => {
                this.vehicleSituation.push({
                    value,
                    text: value,
                });
            });
        } else {
            const fixSituations = [
                "NORMAL",
                "SUJO",
                "PLOTADO",
                "ENVELOPADO",
                "MOLHADO",
            ];
            fixSituations.forEach((value) => {
                this.vehicleSituation.push({
                    value,
                    text: value,
                });
            });
        }

        const situacaoLocalDeAtendimentoValues = this.enterpriseConfig.opcoes_situacao_local_atendimento.valor.split("|");
        situacaoLocalDeAtendimentoValues.forEach((value) => {
            this.situacaoLocalDeAtendimentoOptions.push({
                value,
                text: value,
            });
        });
        

        try {
            this.quizzes = JSON.parse(localStorage.getItem("quizzes"));
            this.quizzes.forEach((quizz) => {
                if (quizz.descricao === this.quizType) {
                    this.qtdePneus = parseInt(quizz.qtdePneus);
                    switch (this.qtdePneus) {
                        case 4:
                            this.listaPneus = [
                                "Dianteiro Esquerdo",
                                "Traseiro Esquerdo",
                                "Dianteiro Direito",
                                "Traseiro Direito",
                            ];
                            break;

                        case 2:
                            this.listaPneus = ["Dianteiro", "Traseiro"];
                            break;

                        default:
                            this.qtdePneus = 5;
                            this.listaPneus = [
                                "Dianteiro Esquerdo",
                                "Traseiro Esquerdo",
                                "Estepe",
                                "Dianteiro Direito",
                                "Traseiro Direito",
                            ];
                    }
                }
            });

            // se for a primeira vez que abre esta pagina de dados,
            // inicializar a variavel dataFields com todos os campos como null
            // exceto o campo Pneus, que deve ser um array com tamanho igual qtde de pneus e com o valor null
            this.fields.forEach((field) => {
                switch(field.descricao) {
                    case "Pneus":
                        if(this.dataFields["Pneus"] == null) {
                            this.dataFields["Pneus"] = Object();
                            for (let i = 0; i < this.qtdePneus; i++) {
                                this.dataFields.Pneus[this.listaPneus[i]] = Object();
                                this.dataFields.Pneus[this.listaPneus[i]].Estado = null;
                                this.dataFields.Pneus[this.listaPneus[i]].Marca = null;
                            }
                        }
                        break;
                    case "Nivel Combustivel": 
                        if(this.dataFields["Nivel Combustivel"] == null) {
                            this.dataFields["Nivel Combustivel"] = 0;
                        }
                        break;
                    case "Nivel do GNV":
                        if(this.dataFields["Nivel Combustivel"] == null) {
                            this.dataFields["Nivel do GNV"] = 0;
                        }
                        break;
                    case "Bateria":
                        if(this.dataFields["Bateria"] == null) {
                            this.dataFields["Bateria"] = {};
                            this.dataFields["Bateria"].estado = null;
                            this.dataFields["Bateria"].marca = null;
                        }
                        break;
                    default: 
                        if(this.dataFields[field.descricao] == null) {
                            this.dataFields[field.descricao] = null;
                        }
                }
            });
            
        } catch (error) {
            console.error(error);
        }

        this.tires = await getTireManufacturers();
        let firstTireFromArray = this.tires[0];
        if (firstTireFromArray.text != "Selecione") {
            this.tires.unshift({ text: "Selecione" });
        }
        
        const utilizaGPS = operationParams["utiliza_gps"]?.ativo ?? false;

        if(utilizaGPS) {
            let coordGPS = null;
            try {
                coordGPS = await this.getLocation();

                if(coordGPS === null){
                    throw new Error("Coordenadas de GPS retornaram vazias");
                } else {
                    this.$store.commit("setCoordGps", coordGPS);
                }
            } catch (error) {
                console.error(error);
                logger(error, {
                    token: this.$store.state.enterprise.enterprise,
                    placa: this.$store.state.inspectionData.numberPlate
                });
                if (error.code === error.PERMISSION_DENIED) {
                    Swal.fire({
                        title: "Erro!",
                        text: "A localização está desligada ou indisponível, por favor ative o GPS!",
                        icon: "error"
                    });
                } else {
                    Swal.fire({
                        title: "Erro!",
                        text: "Houve algum erro ao tentar pegar a localização por GPS. Por favor, ative o GPS.",
                        icon: "error"
                    });
                }
                this.$router.push("/").catch(() => {});
            }
        }
    },

    methods: {
        
        getLocation() {
            return new Promise(function (resolve, reject) {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            resolve(`${position.coords.latitude}, ${position.coords.longitude}`);
                        },
                        (error) => {
                            let standardError = new Error(error.message);
                            Object.assign(standardError, {name: error.constructor.name,code: error.code});

                            if (standardError.code === error.PERMISSION_DENIED) {
                                console.error("O usuário negou o acesso à localização.");
                            } else {
                                console.error("Erro ao obter a localização: ", standardError.message);
                            }
                            reject(standardError);
                        }
                    );
                } else {
                    reject(new Error("Geolocalização não é suportada pelo seu navegador."));
                }
            });
        },
        tratarIntegracao(dadosIntegracao) {
            try {    
                if (
                    this.utilizaIntegracao === true
                    && !this.naoConsultarVistoriasApi
                    && dadosIntegracao.length >= 1
                ) {
                    this.preencherInformacoesIntegracao(dadosIntegracao);
                }
            } catch(error) {
                console.error(error);
            } finally {   
                this.carregandoIntegracao = false;
            }
        },
        async carregarDadosIniciarVistoria() {
            const bloquearInicioVistoriaPlacaInexistente = this.enterpriseConfig?.bloquear_inicio_vistoria_placa_inexistente?.valor === "1";

            try {
                this.carregandoIntegracao = true;
                this.dadosIntegracao = await iniciarVistoria(this.numberPlate);
                const dadosIntegracaoVazios = !(this.dadosIntegracao?.length > 0);
                if(dadosIntegracaoVazios) {
                    throw new Error("Erro na integração: Vistoria anterior não encontrada para essa placa");
                }
            } catch (error) {
                console.error("Erro ao pegar dados da integração", error);
            
                if(error.message.startsWith("Erro na integração:")) {
                    if(bloquearInicioVistoriaPlacaInexistente && this.utilizaIntegracao && !this.naoConsultarVistoriasApi) {
                        const avisoBloqueioVistoriaPlacaInexistente = 
                        [
                            "Erro na integração: Vistoria anterior não encontrada para essa placa",
                            "Erro na integração:",
                            "Erro na integração: ",
                            ""
                        ].includes(error.message ?? "")
                            ? this.enterpriseConfig?.aviso_bloqueio_vistoria_placa_inexistente?.valor
                            : error.message;

                        await Swal.fire({
                            title: avisoBloqueioVistoriaPlacaInexistente,
                            confirmButtonText: "Voltar",
                            showConfirmButton: true
                        });
                        this.$router.push("/").catch(() => {});
                        return;
                    }
                } else if(
                    error.message === "Network Error"
                || error.message.startsWith("timeout")
                || (error?.status >= 500 && error?.status <= 599)
                ) {
                    const result = await Swal.fire({
                        title: "Confirmação",
                        html: "<pre style=\"text-wrap: wrap; font: inherit; color: inherit;\">"
                        + `Devido a um problema de conexão, as informações referentes à placa ${this.numberPlate}`
                        + " não poderão ser ser consultadas.\n\nDeseja continuar sem a consulta?"
                        + "</pre>",
                        showCancelButton: true,
                        cancelButtonText: "Não",
                        showConfirmButton: true,
                        confirmButtonText: "Sim",
                        reverseButtons: true
                    });

                    if(!result.isConfirmed) {
                        this.$router.push("/").catch(() => {});
                        return;
                    }
                } else {
                    await Swal.fire({
                        title: "Erro ao iniciar vistoria",
                        html: "<pre style=\"text-wrap: wrap; font: inherit; color: inherit;\">"
                        + `${error.message}`
                        + "</pre>",
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: "OK"
                    });
                    this.$router.push("/").catch(() => {});
                    return;
                }
            }
        },
        async checarStatusEmpresa() {
            let bloqueado = false;

            let status, mensagem;
            try {
                const result = await statusDaEmpresa();
                status = result.status;
                mensagem = result.mensagem;
            } catch (error) {
                console.error(error);
                Swal.fire({
                    title: "Erro de consulta",
                    text: "Erro ao consultar status de empresa",
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonText: "Fechar",
                });
            }

            if(status === "BLOQUEADO") {
                bloqueado = true;
                try {
                    await Swal.fire({
                        title: "Acesso bloqueado",
                        text: mensagem || "A empresa está inativa",
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: "#d33",
                        cancelButtonText: "Sair",
                    });
                } catch (error) {
                    console.error(error);
                }
            }

            return bloqueado;
        },
        preencherInformacoesIntegracao(dadosIntegracao) {
            this.$set(this.dataFields, "clientName", dadosIntegracao[0].cliente?.nome ?? null);
            this.$set(this.dataFields, "clientEmail", dadosIntegracao[0].cliente?.email ?? null);
            this.$set(this.dataFields, "vehicle", dadosIntegracao[0].veiculo?.nome ?? null);
            this.$set(this.dataFields, "Ano", dadosIntegracao[0].veiculo?.ano ?? null);
            this.$set(this.dataFields, "Chassi", dadosIntegracao[0].veiculo?.chassi ?? null);
            this.$set(this.dataFields, "Cor", dadosIntegracao[0].veiculo?.cor ?? null);
            this.$set(this.dataFields, "Motorista", dadosIntegracao[0].motorista ?? null);
            this.$set(this.dataFields, "Local Atendimento", dadosIntegracao[0].localVistoria ?? null);

            if (dadosIntegracao[0].AssinaturaCliente) {
                this.$store.commit(
                    "setClientRg",
                    dadosIntegracao[0].AssinaturaCliente.Rg
                );
                this.$store.commit(
                    "setClientFullName",
                    dadosIntegracao[0].AssinaturaCliente.Nome
                );
                this.$store.commit(
                    "setClientPhoneNumber",
                    dadosIntegracao[0].AssinaturaCliente.Telefone
                );
            }

            if (dadosIntegracao[0].veiculo?.odometro != "") {
                this.$set(
                    this.dataFields, "Km Odometro",
                    dadosIntegracao[0].veiculo.odometro
                );
            }

            if (dadosIntegracao[0].veiculo?.nivelCombustivel != "") {
                this.$set(
                    this.dataFields, "Nivel Combustivel",
                    dadosIntegracao[0].veiculo.nivelCombustivel
                );
            }

            if (dadosIntegracao[0].veiculo?.nivelGNV != "") {
                this.$set(
                    this.dataFields, "Nivel do GNV",
                    dadosIntegracao[0].veiculo.nivelGNV
                );
            }

            if (dadosIntegracao[0].contrato != "") {
                this.$set(
                    this.dataFields, "Numero Contrato",
                    dadosIntegracao[0].contrato
                );
            }
        },

        resetTire(tireIndex) {
            this.dataFields.Pneus[this.listaPneus[tireIndex]].Marca = null;
            this.$forceUpdate();
        },
        testUtilizaOutraBateria() {
            if (this.dataFields.Bateria.marca == "Outra") {
                this.utilizaOutraBateria = true;
            } else this.utilizaOutraBateria = false;
        },
        update() {
            this.$forceUpdate();
        },
        askSetAllTires(event, numTire) {
            if (event != "Outra") {
                if (numTire === 0 && event != null) {
                    Swal.fire({
                        text: "Alterar marca dos outros pneus para '" + event + "'",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Sim",
                        cancelButtonColor: "#d33",
                        cancelButtonText: "Não",
                        reverseButtons: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            for (let i = 0; i < this.qtdePneus; i++) {
                                this.dataFields.Pneus[this.listaPneus[i]].Marca = event;
                            }
                            this.$forceUpdate();
                        }
                    });
                }
            } else if (event == "Outra") {
                this.dataFields.Pneus[this.listaPneus[numTire]].Marca = "";
                this.$forceUpdate();
            }
        },
        askSetAllStateTires(event, numTire) {
            if (numTire === 0 && event != null) {
                let currentState;
                if (event === "N") currentState = "Novo";
                else if (event === "B") currentState = "Bom";
                else if (event === "R") currentState = "Ruim";
                Swal.fire({
                    text:
                        "Alterar o estado de todos os pneus para '" + currentState + "'",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Sim",
                    cancelButtonColor: "#d33",
                    cancelButtonText: "Não",
                    reverseButtons: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        for (let i = 0; i < this.qtdePneus; i++) {
                            this.dataFields.Pneus[this.listaPneus[i]].Estado = event;
                        }
                        this.$forceUpdate();
                    }
                });
            }
        },
        saveData(event) {
            event.preventDefault();
            const saveStage = new SaveStage();
            saveStage.data(event, this);
        },
        nextStage(event) {
            this.$router.push("/inspection/quiz").catch(() => {});
        }
    },
    beforeRouteLeave(to, from, next) {
        if(this?.$refs?.dataForm != null) {
            const valid = this.$refs.dataForm.reportValidity();
            if(to.path.split("/")[1] !== "inspection"){
                next();
            } else if(valid){ 
                this.$refs.dataForm.requestSubmit();
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
};
</script>

<style lang="scss">
$rail-color: transparent;
$rail-fill-color: #1e90ff;
$knob-color: #4cbde8;
$knob-border: 1px solid white;
$rail-height: 9px;
$slider-height: 50px;

@import "vue-range-slider/dist/vue-range-slider.scss";

#sobreposicao-integracao {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(157, 174, 186, 0.3);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 0 15px;

    #aviso-carregando-integracao {
        font-weight: bold;
        font-size: 1.2em;
        text-align: center;
        color: white;
        margin-top: 15px;
        padding: 8px;
        border-radius: 8px;
        background-color: rgb(96, 107, 117,);
    }
}

.campo-obrigatorio > label:first-of-type,
.campo-obrigatorio > div > label:first-of-type,
label.campo-obrigatorio {
    &::before {
        content: '*'
    }
}

.container.overflow-auto {
    scroll-padding-bottom: 66px;
}

.container-buttons {
    background: linear-gradient(#cdd7d6, white);
    width: 100%;
    position: fixed;
    bottom: 0;
    padding-left: 7%;
    padding-right: 7%;
    padding-bottom: 10px;
    right: 0;
}

input.campo-email:not(.empty):invalid {
    border-color: var(--danger);
}

.div-slider-gnv {
    min-height: auto;
    padding: 0;
    background-image: url(@/assets/imgs/level_gnv.png);
    background-size: cover;
    background-repeat: no-repeat;
}

.range-slider-gnv span {
    margin-top: 5%;
    margin-left: 1%;
}

.range-slider-gnv {
    width: 96%;
    padding-right: 2%;
}

.range-slider-combustivel {
    width: 96%;
    margin-right: 4%;
}

@media only screen and (max-width: 300px) {
    .div-slider-combustivel {
        min-height: auto;
        padding: 0;
        background-image: url(@/assets/imgs/level.png);
        background-size: 100% 130%;
        background-repeat: no-repeat;
    }

    .range-slider-combustivel span {
        margin-top: 7%;
        margin-left: 1%;
    }
}

@media only screen and (min-width: 301px) and (max-width: 500px) {
    .div-slider-combustivel {
        min-height: auto;
        padding: 0;
        background-image: url(@/assets/imgs/level.png);
        background-size: 100% 130%;
        background-repeat: no-repeat;
    }

    .range-slider-combustivel span {
        margin-top: 5%;
        margin-left: 1%;
    }
}

@media only screen and (min-width: 501px) and (max-width: 600px) {
    .div-slider-combustivel {
        min-height: auto;
        padding: 0;
        background-image: url(@/assets/imgs/level.png);
        background-size: 100% 130%;
        background-repeat: no-repeat;
    }

    .range-slider-combustivel span {
        margin-top: 3%;
        margin-left: 1%;
    }
}

@media only screen and (min-width: 601px) and (max-width: 800px) {
    .div-slider-gnv {
        min-height: auto;
        padding: 0;
        background-image: url(@/assets/imgs/level_gnv.png);
        background-size: 100% 150%;
        background-repeat: no-repeat;
    }

    .div-slider-combustivel {
        min-height: auto;
        background-image: url(@/assets/imgs/level.png);
        background-size: 100% 130%;
        background-repeat: no-repeat;
    }

    .range-slider-combustivel span {
        margin-top: 2.5%;
        margin-left: 1%;
    }

    .range-slider-gnv span {
        margin-top: 2.5%;
        margin-left: 1%;
    }
}

@media only screen and (min-width: 801px) {
    .div-slider-gnv {
        min-height: auto;
        padding: 0;
        background-image: url(@/assets/imgs/level_gnv.png);
        background-size: 100% 150%;
        background-repeat: no-repeat;
    }

    .div-slider-combustivel {
        min-height: auto;
        background-image: url(@/assets/imgs/level.png);
        background-size: 100% 130%;
        background-repeat: no-repeat;
    }

    .range-slider-combustivel span {
        margin-top: 1.8%;
        margin-left: 1%;
    }

    .range-slider-gnv span {
        margin-top: 2.5%;
        margin-left: 1%;
    }
}

.resetTire {
    width: 30px;
    height: 30px;
    margin: 2px;
    margin-top: 4px;
    background-color: #dadada;
    border: 1px solid gray;
    border-radius: 4px;
}

.buttons {
    float: right;
    width: 100px;
}

.div-pneu {
    padding-top: 4%;
    display: flex;
    align-content: center;
    justify-content: space-between;
}

.label-pneu {
    align-content: center;
    margin: 0;
    display: flex;
    align-items: center;
    width: 25%;
}

.select-estado-pneu {
    width: 35%;
    margin-right: 2%;
}

.select-pneu {
    width: 40%;
}
</style>
